export enum CentrifugoSocketChannelsEnum {
  NOTIFICATION = 'personal:user#doctor_', //full channel - personal:user#doctor_${id}
  DISCUSSION = 'discussion:clinic_', //full channel - discussion:clinic_${id}_chat_${id}
  CHAT = 'consultation:chat_', //full channel - consultation:chat_${id}
  WAITING_AREA = 'public:clinic_' //full channel - public:clinic_${id}.waitingArea
}
